import axios from './axios';

// Every simple CRUD module on the backend follows the same Model/Router convention
// (AreaModel.js/AreaRouter.js pattern): GET /getAll, GET /get/:id, POST /add,
// PUT /modify/:id, DELETE /delete/:id. This factory avoids repeating that boilerplate
// for every one of governorates/cities/districts/zones/roles/bundles/fees/etc.
export const createResourceApi = (basePath) => ({
  list: async (params) => (await axios.get(`${basePath}/getAll`, { params })).data.data,
  getOne: async (id) => (await axios.get(`${basePath}/get/${id}`)).data.data,
  create: async (payload) => (await axios.post(`${basePath}/add`, payload)).data.data,
  update: async (id, payload) => (await axios.put(`${basePath}/modify/${id}`, payload)).data.data,
  remove: async (id) => (await axios.delete(`${basePath}/delete/${id}`)).data.data
});

export default createResourceApi;
